import { render, staticRenderFns } from "./NotificationConfigDetails.vue?vue&type=template&id=69a74a03&scoped=true"
import script from "./NotificationConfigDetails.vue?vue&type=script&lang=js"
export * from "./NotificationConfigDetails.vue?vue&type=script&lang=js"
import style0 from "./NotificationConfigDetails.vue?vue&type=style&index=0&id=69a74a03&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69a74a03",
  null
  
)

export default component.exports